/**
 * Daily-hours notification recipients (employee drawer multi-select).
 * `label` is shown in the UI; `value` is the email stored on the user (comma-separated).
 */
export const DAILY_HOURS_NOTIFY_RECIPIENT_OPTIONS = [
  { label: "Himanshu", value: "himanshu@thecodingstudio.in" },
  { label: "Anjali", value: "anjali@thecodingstudio.in" },
  { label: "Rishi", value: "rishi@thecodingstudio.in" },
  { label: "Shalini", value: "shalini@thecodingstudio.in" },
  { label: "HR", value: "suhotra@thecodingstudio.in" },
];

/** Same people list for leave-request notifications. */
export const LEAVE_REQUEST_NOTIFY_RECIPIENT_OPTIONS = DAILY_HOURS_NOTIFY_RECIPIENT_OPTIONS;

/** Fixed CC recipients for salary slip emails (not the employee directory). */
export const SALARY_SLIP_CC_RECIPIENT_OPTIONS = DAILY_HOURS_NOTIFY_RECIPIENT_OPTIONS;
